import { GET_CART_PRODUCTS, TAXES_TO_APPLY, CART_IS_LOADING, CART_IS_NOT_LOADING, CLEAN_CART } from '../actions'
import { IActionObject, ITax } from '../interface'

const initialState = {
  cart: [],
  coupon: null,
  isCartLoading: false,
  taxes: [],
  taxRate: 0,
  totalPrice: 0,
  totalTax: 0,
  trialMemberships: {}
}

export const cartFormDynamoReducer = (state = initialState, action: IActionObject) => {
  switch (action.type) {
    case GET_CART_PRODUCTS:
      let newContent = { cart: [...action.payload.Items] }
      delete action.payload.Items
      newContent = { taxes: state.taxes, ...newContent, ...action.payload, isCartLoading: false }
      return newContent
    case TAXES_TO_APPLY:
      let taxRate = 0
      action.payload.data && action.payload.data.forEach((item: ITax) => (taxRate += item.percentage))
      return { ...state, taxes: action.payload.data, taxRate }
    case CART_IS_LOADING:
      return { ...state, isCartLoading: true }
    case CART_IS_NOT_LOADING:
      return { ...state, isCartLoading: false }
    case CLEAN_CART:
      const initialStateWithTaxes = { ...initialState }
      initialStateWithTaxes.taxes = state.taxes
      initialStateWithTaxes.taxRate = state.taxRate
      return initialStateWithTaxes
    default:
      return state
  }
}
